import { ReactNode } from 'react';
import { cn } from './shadcn/utils';

export function EnvBanner({ children }: { children: ReactNode }) {
  const env = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;

  if (env === 'production') return children;
  return (
    <div>
      <div className={cn('fixed right-0 z-50 text-white', env === 'staging' ? 'bg-purple-500' : 'bg-red-500')} id="env-banner">
        {env}
      </div>
      {children}
    </div>
  );
}
